// extracted by mini-css-extract-plugin
export default {"table":"MyTable_table__7WNOD","lastRow":"MyTable_lastRow__jYhPl"};